export const ASSESSMENT_ANSWERS_QUERY = '/assessment/answers';
export const NEW_IN_SCOPE_DOMAINS_QUERY = '/quickanswer/newInScopeDomains';
export const REASSESMENT_STATUS_QUERY = '/reassessment/status';
export const QUICK_ANSWER_CONFIG_QUERY = '/quickanswer/config';
export const QUICK_ANSWER_JOBS_QUERY = '/quickanswer/jobs';
export const QUICK_ANSWER_SUGGESTIONS_QUERY = '/quickanswer/suggestions';
